import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/chevron-down-white.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "absolute z-20 mt-2 w-full max-w-[320px] bg-layer-2 border border-stroke-separator rounded-lg shadow-lg p-3"
}

import { ref, computed } from 'vue'
import LanguagePicker from '@/components/session/LanguagePicker.vue'
import { useLanguages } from '@/composables/useLanguages'

// showFlags: flags on the button and in the list, as in the room's language picker.

export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSelect',
  props: {
    modelValue: {},
    showFlags: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const emit = __emit

const { getLanguageName } = useLanguages()

const open = ref(false)
const languageName = computed(() => getLanguageName(props.modelValue))

function onSelect(code: string) {
  emit('update:modelValue', code)
  open.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "flex items-center justify-between w-full h-11 px-3 border border-stroke-separator rounded-lg bg-transparent text-text-neutral-extreme outline-none focus:border-elements-blue cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value))
    }, [
      _createElementVNode("span", _hoisted_2, [
        (props.showFlags)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: '/data/flags/' + props.modelValue + '.png',
              class: "w-4 h-4 rounded-full overflow-hidden",
              alt: ""
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(languageName.value), 1)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "w-4 h-4",
        alt: ""
      }, null, -1))
    ]),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(LanguagePicker, {
            initial: props.modelValue,
            "close-on-select": false,
            "show-flags": props.showFlags,
            onSelect: onSelect
          }, null, 8, ["initial", "show-flags"])
        ]))
      : _createCommentVNode("", true),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 z-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (open.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})